import { FontWeight, Heading } from '@lili/lili-frontend-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as PendingClockIcon } from '../../assets/icons/svg/colored-icons/ic-colored-watch.svg';
import { ChangeInvalidBusinessAddress } from './changeAddress/ChangeInvalidBusinessAddress';
import { UpdateInvalidBusinessAddressProps } from './UpdateInvalidBusinessAddress';

export const UpdateInvalidBusinessAddressForm = ({
  onAddressUpdated,
}: UpdateInvalidBusinessAddressProps) => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col items-center justify-center bg-bw01 rounded-[12px] height-[460px] animate-fadeIn px-[32px] pt-[32px] pb-[32px] w-[504px]'>
      <PendingClockIcon className='mb-[32px]' />
      <Heading.H5 fontWeight={FontWeight.MEDIUM} className='text-text-main-primary mb-[8px]'>{t('UPDATE_BUSINESS_ADDRESS.MODAL_TITLE')}</Heading.H5>
      <Heading.H10 className='text-text-main-secondary'>{t('UPDATE_BUSINESS_ADDRESS.MODAL_DESCRIPTION')}</Heading.H10>
      <ChangeInvalidBusinessAddress onAddressUpdatedSuccessfully={onAddressUpdated} />
    </div>
  );
};
